import { InboxPage } from 'common/components/inbox';
import protect from 'common/HoC/protect';
import React from 'react';

function Inbox() {
  return <InboxPage />;
}

export default React.memo(protect(Inbox));
